import { useMutation, useQueryClient } from '@tanstack/react-query'
import { api } from '@api'
import { showSuccessToast } from '@utils'
import { useLanguage } from '@context'

interface DeleteNoteParams {
  id: string
}

const deleteNote = async ({ id }: DeleteNoteParams): Promise<void> => {
  await api.delete(`/note/${id}`)
}

export const useDeleteNote = () => {
  const queryClient = useQueryClient()
  const { t } = useLanguage()

  return useMutation<void, Error, DeleteNoteParams>({
    mutationFn: deleteNote,
    onSuccess: async (_, variables) => {
      showSuccessToast(t('toast.success'), t('toast.noteDeleted'))
      await Promise.all([
        queryClient.invalidateQueries({ queryKey: ['notes'] }),
        queryClient.invalidateQueries({ queryKey: ['note', variables.id] }),
        // « Historique avec X » must not keep a line that opens a deleted note.
        queryClient.invalidateQueries({ queryKey: ['contact-history'] }),
        // « Ce que je sais de X » is asked again only here: what a deleted note
        // said must not stay on screen. Saving does not ask the AI (see
        // useGetNotesSummary).
        queryClient.invalidateQueries({ queryKey: ['notes-summary'] }),
      ])
    },
  })
}

